module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/service/Frame_4268@2x.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fservice%2FFrame_4268%402x.png
// module id = DLtV
// module chunks = 93